import { BASE_PATH, UserRoles } from "src/constants/api";
import { IPowerBiReport } from "./interfaces";

/** API :- define urls for api */
export const POWER_BI_API_URLS = {
  GET_POWER_BI_REPORT: `${BASE_PATH}/PBIEmbedDashboard/GetPBIEmbedInfoByReportId`,
};

// dispaly monitoring power bi dashboards
export const menuMonitoring: Array<IPowerBiReport> = (window as any)
  .menuMonitoring;
